// 所有表格行相同的配置
const columnPublicConfig = {
    align: 'center'
}

// 编辑内容配置
export const formModel = {
    name: {
        title: '商品名称',
        type: 'input',
        aliasType: 'text',
        value: '',
        rules: [{
            required: true,
            message: '请输入商品名称'
        }]
    },
    specification: {
        title: '商品规格',
        type: 'input',
        aliasType: 'text',
        value: '',
        rules: [{
            required: true,
            message: '请输入商品规格'
        }]
    },
    money: {
        title: '价格',
        type: 'input',
        aliasType: 'text',
        value: '',
        rules: [{
            required: true,
            message: '请输入价格'
        }]
    },
    weight: {
        title: '重量',
        type: 'input',
        aliasType: 'text',
        value: '',
        rules: [{
            required: true,
            message: '请输入重量'
        }]
    },
    ymd: {
        title: '年份',
        type: 'input',
        aliasType: 'text',
        value: ''
    },
    is_purpose: {
        title: '是否常用',
        type: 'switch',
        value: 0
    },
    is_weights: {
        title: '重量可修改',
        type: 'switch',
        value: 0
    },
    is_prices: {
        title: '价格可修改',
        type: 'switch',
        value: 0
    },
    is_autoWeights: {
        title: '重量自动计算',
        type: 'switch',
        value: 1
    },
    is_autoPrices: {
        title: '价格自动计算',
        type: 'switch',
        value: 1
    },
    rule: {
        title: '计算公式',
        type: 'input',
        aliasType: 'text',
        value: '总重量/13.5*分组价格',
        extra: {
            hint: '支持四则运算（ + - * / ），关键字请使用"总数量"，"总重量"，"原价"，"分组价格"'
        }
    }
}

// 表格配置
/**
 * title: 表格标题
 * dataIndex: 后端返回的这个标题的名字
 * filterIndex: 筛选器字段，一般和dataIndex一样，如果是选择型的筛选器，这里填写id字段
 * key: 随便选择dataIndex或filterIndex中的一个
 * type: 筛选器类型，input = 输入框，select = 选择框
 * multi: 如果选择型筛选器需要多选，就写上值为true
 * items: 选择型筛选器必须带上这个，默认为空数组
 */
export const columns = [{
    title: '商品名称',
    dataIndex: 'name',
    key: 'name',
    ...columnPublicConfig,
},
{
    title: '商品规格',
    dataIndex: 'specification',
    key: 'specification',
    ...columnPublicConfig,
},
{
    title: '价格',
    dataIndex: 'money',
    key: 'money',
    ...columnPublicConfig,
},
{
    title: '重量',
    dataIndex: 'weight',
    key: 'weight',
    ...columnPublicConfig
},
{
    title: '年份',
    dataIndex: 'ymd',
    key: 'ymd',
    ...columnPublicConfig
},
{
    title: '更新时间',
    dataIndex: 'updated_at',
    key: 'updated_at',
    ...columnPublicConfig
},
{
    title: '操作',
    dataIndex: 'action',
    key: 'action',
    width: 240,
    scopedSlots: {
        customRender: 'c-action'
    }
}]
